import { t as throttle, p as position, _ as _asyncToGenerator, r as regenerator, b as _toConsumableArray, c as _objectSpread2, s as src, e as entry, f as handleUrl, E as EventHub } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import Vue from 'vue';
import { n as normalizeComponent } from './normalize-component.js';
import { h as hotspotsMixin } from './hotspots.js';
import __vue_component__$1 from './PanzoomMap.js';

var dragDetector = {
  date: function date() {
    return {
      isDragged: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.onStart = throttle(function (e) {
      _this.isDown = true;
      _this.startTime = Date.now();
      _this.isDragged = false;
      _this.startPosition = position(e);
    });
    this.onEnd = throttle(function () {
      _this.isDown = false;
    });
    this.onMove = throttle(function (e) {
      if (_this.isDown) {
        var currentPosition = position(e);
        var dX = Math.abs(_this.startPosition.top - currentPosition.top);
        var dY = Math.abs(_this.startPosition.left - currentPosition.left);

        if (dX >= 3 || dY >= 3 || Date.now() - _this.startTime > 800) {
          _this.isDragged = true;
        }
      }
    });
    document.addEventListener('touchstart', this.onStart);
    document.addEventListener('mousedown', this.onStart);
    document.addEventListener('touchmove', this.onMove);
    document.addEventListener('mousemove', this.onMove);
    document.addEventListener('touchend', this.onEnd);
    document.addEventListener('mouseup', this.onEnd);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('touchstart', this.onStart);
    document.removeEventListener('mousedown', this.onStart);
    document.removeEventListener('touchmove', this.onMove);
    document.removeEventListener('mousemove', this.onMove);
    document.removeEventListener('touchend', this.onEnd);
    document.removeEventListener('mouseup', this.onEnd);
  }
};

var XpImg = Vue.extend({
  name: 'XpImg',
  mixins: [hotspotsMixin, dragDetector],
  props: {
    src: String,
    alt: String,
    width: Number,
    height: Number,
    placeholderSrc: String
  },
  data: function data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: !!this.src,
      isComplete: false,
      // Preview wurde durch Vollversion ersetzt. Alles fertig.
      hasError: false,
      naturalRatio: undefined,
      svgImageBoundingClientRect: null,
      xpImageBoundingClientRect: null,
      imageID: 'i' + Math.random().toString(16).slice(2),
      iconSize: this.$xp.content.pageData.IconSize ? this.$xp.content.pageData.IconSize : 100 // Größe ImageMap-Icons in %

    };
  },
  watch: {
    src: function src() {
      this.__load();
    }
  },
  computed: {
    url: function url() {
      return this.currentSrc || this.placeholderSrc || undefined;
    },
    style: function style() {
      return {
        width: Number(this.width),
        height: Number(this.height),
        backgroundImage: 'url(' + this.url + ')'
      };
    }
  },
  created: function created() {
    var _this = this;

    this.screenUnwatcher = this.$watch(function () {
      return [// this.$xp.screen.orientation,
      _this.$xp.screen.width, _this.$xp.screen.height].join();
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$nextTick();

            case 2:
              setTimeout(function () {
                _this.__updateImageBoundingRect();
              }, 0);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log('XpImg mounted', this.$el);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          _this2.__updateImageBoundingRect();
        }
      });
    }, {});
    observer.observe(this.$el);
  },
  methods: {
    __onLoad: function __onLoad(img) {
      this.isLoading = false;
      this.hasError = false;

      this.__computeRatio(img);

      this.__updateSrc();

      this.__updateImageBoundingRect();

      this.$emit('load', this.currentSrc);
    },
    __updateImageBoundingRect: function __updateImageBoundingRect() {
      this.xpImageBoundingClientRect = this.$el.getBoundingClientRect().toJSON();
      this.svgImageBoundingClientRect = this.$el.querySelector('svg image') ? this.$el.querySelector('svg image').getBoundingClientRect().toJSON() : null;
    },
    __onError: function __onError(err) {
      console.warn(err);
      this.isLoading = false;
      this.hasError = true;
      this.currentSrc = '';
      this.$emit('error', err);
    },
    __updateSrc: function __updateSrc() {
      var _this3 = this;

      if (this.image !== undefined && this.isLoading === false) {
        var src = this.image.currentSrc || this.image.src;

        if (this.currentSrc !== src) {
          this.currentSrc = src;
          setTimeout(function () {
            // Timeout, da sonst Bild einen winzigen Moment in Thumbnail-Size zu sehen ist
            _this3.isComplete = true;
          }, 50);
        }
      }
    },
    __load: function __load() {
      var _this4 = this;

      this.hasError = false;

      if (!this.src) {
        this.isLoading = false;
        this.image = undefined;
        this.currentSrc = '';
        return;
      }

      this.isLoading = true;
      var img = new Image();
      this.image = img;
      this.$xp.http.getFileUrl(this.src).then(function (data) {
        if (_this4.destroyed === true) {
          return;
        }

        img.src = data; // if we are still rendering same image

        if (_this4.image === img) {
          _this4.__onLoad(img);
        }
      }).catch(function (error) {
        // if we are still rendering same image
        if (_this4.image === img && _this4.destroyed !== true) {
          _this4.__onError(error);
        }
      });
      Object.assign(img, {
        height: this.height,
        width: this.width
      });
    },
    __hotspotClickHandler: function __hotspotClickHandler(event) {
      var coords = position(event);
      var bb = event.target.getBoundingClientRect();
      this.checkForHotspot([(coords.left - bb.left) / bb.width * 100, (coords.top - bb.top) / bb.height * 100]);
    },
    __computeRatio: function __computeRatio(img) {
      var _this5 = this;

      var naturalHeight = img.naturalHeight,
          naturalWidth = img.naturalWidth;

      if (naturalHeight || naturalWidth) {
        this.naturalRatio = naturalHeight === 0 ? 1 : naturalWidth / naturalHeight;
      } else {
        this.ratioTimer = setTimeout(function () {
          if (_this5.image === img && _this5.destroyed !== true) {
            _this5.__computeRatio(img);
          }
        }, 100);
      }
    }
  },
  render: function render(h) {
    var _this6 = this;

    if (this.width && this.height && this.hotspots.length) {
      return h('div', {
        staticClass: 'xp-img',
        style: this.style
      }, [h('div', {
        staticClass: 'xp-img__background-cover'
      }), h('svg', {
        attrs: {
          width: '100%',
          height: '100%',
          viewBox: "0, 0, ".concat(this.width, ", ").concat(this.height),
          version: '1.1',
          'xmlns:xlink': 'http://www.w3.org/1999/xlink',
          role: 'img',
          'aria-labelledby': "binarylabel".concat(this.imageID)
        }
      }, [h('title', {
        attrs: {
          id: "binarylabel".concat(this.imageID)
        }
      }, this.alt), h('image', {
        attrs: {
          width: this.width,
          height: this.height,
          'xlink:href': this.url,
          'data-binary-src': this.src
        }
      })].concat(_toConsumableArray(this.svgHotspots.map(function (hotspot) {
        _this6.hotspotShapAttrs = function () {
          switch (hotspot.shape) {
            case 'rect':
              return {
                width: (hotspot.br.x - hotspot.tl.x) * _this6.width / 100,
                height: (hotspot.br.y - hotspot.tl.y) * _this6.height / 100,
                x: hotspot.tl.x * _this6.width / 100,
                y: hotspot.tl.y * _this6.height / 100
              };

            case 'circle':
              return {
                cx: hotspot.center.x * _this6.width / 100,
                cy: hotspot.center.y * _this6.height / 100,
                r: hotspot.radius * _this6.width / 100
              };

            case 'polygon':
            case 'poly':
              {
                var coords = [];
                hotspot.points.map(function (point) {
                  coords.push(point.x * _this6.width / 100 + ',' + point.y * _this6.height / 100);
                });
                return {
                  points: coords.join(' ')
                };
              }
          }
        }();

        return h(hotspot.shape === 'poly' ? 'polygon' : hotspot.shape, {
          staticClass: 'xp-img__svg-path',
          on: {
            touchend: function touchend(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            },
            mouseup: function mouseup(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            }
          },
          attrs: Object.assign({
            fill: 'transparent',
            'aria-hidden': true
          }, _this6.hotspotShapAttrs)
        }, []);
      }))))].concat(_toConsumableArray(!this.isLoading ? this.htmlIconHotspots.map(function (hotspot) {
        return h('button', {
          class: "xp xp--large xp-img__hotspot-icon xp-img__hotspot-icon--".concat(hotspot.icon),
          style: {
            top: ((_this6.xpImageBoundingClientRect.height - _this6.svgImageBoundingClientRect.height) / 2 + hotspot.centerYPercent * _this6.svgImageBoundingClientRect.height) / _this6.xpImageBoundingClientRect.height * 100 + '%',
            left: ((_this6.xpImageBoundingClientRect.width - _this6.svgImageBoundingClientRect.width) / 2 + hotspot.centerXPercent * _this6.svgImageBoundingClientRect.width) / _this6.xpImageBoundingClientRect.width * 100 + '%',
            borderRadius: 0.333334 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            borderWidth: 2 / window.devicePixelRatio * _this6.iconSize / 100 + 'px',
            height: 4 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            margin: -2 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem' + ' 0 0 -' + 3 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            width: 6 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            fontSize: (hotspot.icon === 'display' ? 2.75 / window.devicePixelRatio * _this6.iconSize / 100 : 5 / window.devicePixelRatio * _this6.iconSize / 100) + 'rem',
            paddingTop: hotspot.icon === 'display' ? 0.35 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem' : '0'
          },
          attrs: {
            href: hotspot.href,
            title: hotspot.alt === '' || hotspot.alt === undefined ? '' : hotspot.alt,
            role: 'link'
          },
          on: {
            touchend: function touchend(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            },
            mouseup: function mouseup(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            }
          }
        }, hotspot.icon === 'display' && hotspot.icontext ? hotspot.icontext : '');
      }) : []), _toConsumableArray(this.svgHotspots.map(function (hotspot) {
        return h('span', {
          on: {
            touchend: function touchend(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            },
            mouseup: function mouseup(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            }
          },
          class: 'sr-only',
          attrs: Object.assign({
            role: 'link',
            title: hotspot.alt === '' || hotspot.alt === undefined ? '' : hotspot.alt,
            tabindex: 0,
            fill: 'transparent'
          }, _this6.hotspotShapAttrs)
        }, []);
      }))));
    }

    return h('div', {
      class: 'xp-img',
      style: this.style
    }, [h('div', {
      staticClass: 'xp-img__background-cover'
    }), h('img', {
      staticClass: 'xp-img__image',
      class: !this.isComplete ? 'preview' : '',
      attrs: {
        src: this.url,
        'data-binary-src': this.src,
        alt: this.alt === '' || this.alt === undefined ? this.$xp.content.pageData.Title : this.alt
      },
      style: {
        filter: this.isLoading ? 'blur(10px)' : null
      },
      on: this.hotspots !== undefined && this.hotspots.length > 0 ? _objectSpread2(_objectSpread2({}, this.$listeners), {}, {
        mouseup: this.__hotspotClickHandler,
        touchend: this.__hotspotClickHandler
      }) : this.$listeners // , 'touchend': this.__getHotspotLister(), 'mouseup': this.__getHotspotLister()}

    })]);
  },
  beforeMount: function beforeMount() {
    var _this7 = this;

    if (this.placeholderSrc !== undefined) {
      var img = new Image();
      img.src = this.placeholderSrc;

      img.onload = function () {
        _this7.__computeRatio(img);
      };
    }

    this.isLoading === true && this.__load();
    console.log('beforeMount', this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyed = true;
    this.screenUnwatcher();
    this.isLoading && this.$xp.http.cancelRequest(this.src);
    this.image.src = ''; // to abort loading
  }
});

var log = src('xpedeo-core:ImageEntry');
src.enable(process.env.VUE_APP_DEBUG);
var script = {
  mixins: [entry],
  components: {
    PanzoomMap: __vue_component__$1,
    XpImg: XpImg
  },
  props: {
    mode: {
      type: String,
      default: 'image',
      validator: function validator(value) {
        if (['map', 'image'].includes(value)) {
          return true;
        } else {
          console.warn('ImageEntry: mode property can either be "map" or "image');
          return false;
        }
      }
    }
  },
  computed: {
    imageUrl: function imageUrl() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.$xp.content.getImageUrl(this.entryData.Image, this.mode === 'map' ? 0 : this.imageWidth);
    },
    zoomImageUrl: function zoomImageUrl() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.$xp.content.getImageUrl(this.entryData.Image, 0);
    },
    imageHeight: function imageHeight() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.mode === 'map' ? Number(this.entryData.Image.Height) : Math.round(this.imageWidth / this.entryData.Image.Width * this.entryData.Image.Height);
    },
    imageWidth: function imageWidth() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.mode === 'map' ? this.entryData.Image.Width : this.$xp.content.getRequiredImageWidth(this.entryData.Image);
    } //  this.imageWidth = this.$xp.content.getRequiredImageWidth(this.entryData.Image)
    //         this.imageHeight = Math.round(this.imageWidth / Number(this.entryData.Image.Width) * Number(this.entryData.Image.Height))
    //         this.imageUrl = this.$xp.content.getImageUrl(this.entryData.Image, this.imageWidth)

  },
  data: function data(vm) {
    return {
      isCaptionActive: false,
      isZoomDialogActive: false,
      // imageWidth: vm.mode === 'map' ? Number(vm.entryData.Image.Width) : vm.$xp.content.getRequiredImageWidth(vm.entryData.Image),
      // imageHeight: vm.mode === 'map' ? Number(vm.entryData.Image.Height) : Math.round(vm.imageWidth / vm.entryData.Image.Width * vm.entryData.Image.Height),
      // imageUrl: null,
      // zoomImageUrl: null,
      // imageUrlData: null,
      ScaleToScreenHeight: this.entryData.ScaleToScreenHeight,
      shouldRecomputeImageVariables: 0 // this is a hack to force recompute of image variables see : https://logaretm.com/blog/forcing-recomputation-of-computed-properties/

    };
  },
  created: function created() {
    // EventHub.Bus.$on(EventHub.TYPES.RE_INIT_IMAGE_MAP, this.initImageMap)
    log('created', this.ScaleToScreenHeight);
    this.onAreaClick = throttle(this.onAreaClick); // this.imageWidth = this.mode === 'map' ? this.entryData.Image.Width : this.$xp.content.getRequiredImageWidth(this.entryData.Image)
    // this.imageHeight = this.mode === 'map' ? Number(this.entryData.Image.Height) : Math.round(this.imageWidth / this.entryData.Image.Width * this.entryData.Image.Height)
    // this.imageUrl = this.$xp.content.getImageUrl(this.entryData.Image, this.mode === 'map' ? 0 : this.imageWidth)
    // this.zoomImageUrl = this.$xp.content.getImageUrl(this.entryData.Image, 0)
    // this.$xp.navigation.checkScreenReader().then(() => {

    if (this.$xp.navigation.isScreenReader) this.isCaptionActive = true; // })
  },
  mounted: function mounted() {
    var _this = this;

    if (this.entryData.Json.Href && this.entryData.Json.Href.length > 0 && !this.entryData.Json.ImageMap.length) {
      this.$el.querySelector('.xp-img img').addEventListener('click', function () {
        handleUrl(_this.entryData.Json.Href, _this.$router);
      });
    }
  },
  methods: {
    onAreaClick: function onAreaClick(hotspot) {
      console.log('onAreaClick');

      if (this.pageData.Class === 'XpSplashScreen') {
        EventHub.Bus.$emit(EventHub.TYPES.CLICKED_HOTSPOT_SPLASHSCREEN);
      }

      if (hotspot.href.length > 0) {
        handleUrl(hotspot.href, this.$router);
      } else if (hotspot.route && hotspot.route.length > 0 && hotspot.route.startsWith('/page/')) {
        this.$router.push(hotspot.route);
      }
    },
    onCaptionClick: function onCaptionClick() {
      this.isCaptionActive = !this.isCaptionActive;
    },
    onZoomDialogClick: function onZoomDialogClick() {
      var _this2 = this;

      if (!this.isZoomDialogActive) {
        this.$xp.navigation.hideNav();
        this.$xp.navigation.preventAutoHide();
        this.isZoomDialogActive = true;
        this.$xp.media.setIsImageZoomDialogActive(true);
      } else {
        this.isZoomDialogActive = false;
        this.$xp.media.setIsImageZoomDialogActive(false);
        setTimeout(function () {
          _this2.$xp.navigation.allowAutoHide();

          _this2.$xp.navigation.showNav(true);
        }, 200);
      }
    }
  },
  watch: {
    '$xp.screen.orientation': {
      handler: function handler() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // await this.$nextTick()
                  _this3.shouldRecomputeImageVariables++; // if (this.mode !== 'map') {
                  //   setTimeout(() => {
                  //     this.imageWidth = this.$xp.content.getRequiredImageWidth(this.entryData.Image)
                  //     this.imageHeight = Math.round(this.imageWidth / Number(this.entryData.Image.Width) * Number(this.entryData.Image.Height))
                  //     this.imageUrl = this.$xp.content.getImageUrl(this.entryData.Image, this.imageWidth)
                  //   }, 1000)
                  // }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    },
    '$xp.navigation.isScreenReader': {
      handler: function handler() {
        var _this4 = this;

        return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (_this4.$xp.navigation.isScreenReader) _this4.isCaptionActive = true;

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: {
        "js-entry": true,
        "o-entry": true,
        "c-image-entry": true,
        "c-image-entry--map-mode": _vm.mode === "map",
        "scale-to-screenheight": this.ScaleToScreenHeight
      }
    },
    [
      _c(
        "div",
        { staticClass: "c-image-entry__view" },
        [
          _c("xp-img", {
            attrs: {
              src: _vm.imageUrl,
              width: _vm.imageWidth,
              height: _vm.imageHeight,
              hotspots: _vm.entryData.Json.ImageMap || [],
              alt: _vm.entryData.Image.Alt,
              placeholderSrc: _vm.entryData.Image.Thumb
            },
            on: { "hotspot-click": _vm.onAreaClick }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "c-image-entry__btns": true,
            "is-hidden": _vm.$xp.navigation.isNavHidden
          }
        },
        [
          _vm.entryData.Json.Link2FullSize
            ? _c(
                "button",
                {
                  class: {
                    "c-image-entry__zoom-btn": true,
                    "js-zoom-dialog": true
                  },
                  attrs: { "aria-hidden": "true" },
                  on: { click: _vm.onZoomDialogClick }
                },
                [
                  _c("span", {
                    staticClass: "xp xp-zoom-in xp--large",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.entryData.Json.Caption && _vm.entryData.Json.Caption.length > 0
            ? _c(
                "button",
                {
                  class: {
                    "c-image-entry__caption-btn": true,
                    "js-caption": true
                  },
                  attrs: {
                    "aria-label": _vm.$t(
                      _vm.isCaptionActive
                        ? "global.srHideImageInfo"
                        : "global.srShowImageInfo"
                    )
                  },
                  on: { click: _vm.onCaptionClick }
                },
                [
                  _c("span", {
                    staticClass: "xp xp-information xp--large",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.entryData.Json.Caption && _vm.entryData.Json.Caption.length > 0
        ? _c(
            "div",
            {
              class: {
                "c-image-entry__caption": true,
                "js-caption": true,
                "c-image-entry__caption--overlay": true,
                "c-image-entry__caption--overlay--active": _vm.isCaptionActive
              },
              attrs: {
                "aria-label": _vm.$t(
                  _vm.isCaptionActive
                    ? "global.srHideImageInfo"
                    : "global.srShowImageInfo"
                )
              },
              on: { click: _vm.onCaptionClick }
            },
            [_vm._v("\n    " + _vm._s(_vm.entryData.Json.Caption) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Link2FullSize
        ? _c(
            "transition",
            {
              attrs: {
                "enter-active-class": "animated fadeIn",
                "leave-active-class": "animated fadeOut",
                mode: "out-in",
                duration: 200
              }
            },
            [
              _vm.isZoomDialogActive
                ? _c(
                    "div",
                    { class: { "c-image-entry__zoom-dialog": true } },
                    [
                      _c(
                        "panzoom-map",
                        {
                          attrs: {
                            height: _vm.entryData.Image.Height,
                            width: _vm.entryData.Image.Width,
                            "start-center": {
                              x: _vm.entryData.Image.Width / 2,
                              y: _vm.entryData.Image.Height / 2
                            }
                          }
                        },
                        [
                          _c("xp-img", {
                            attrs: {
                              src: _vm.zoomImageUrl,
                              hotspots: [],
                              placeholderSrc: _vm.entryData.Image.Thumb
                            },
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault();
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-image-entry__zoom-btn",
                          on: { click: _vm.onZoomDialogClick }
                        },
                        [
                          _c("span", {
                            staticClass: "xp xp-close xp--large",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=ImageEntry.js.map
